import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { Count } from '../../../models/count';
import { fetchAllSearchPages } from './fetchAllSearchPages';
import { normalizeSchoolUserContactSearchWhere } from './schoolUserContactSearch';

const DEFAULT_GOVERNORS_FILTER: any = {
  'permissions.preset': { $in: ['GOVERNOR'] }
};

export function getGovernors(user: AppUser, filter = DEFAULT_GOVERNORS_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        where: {
          ...DEFAULT_GOVERNORS_FILTER,
          ...filter.where
        },
        skip: filter.skip,
        limit: filter.limit,
        order: filter.order
      }
    }
  };

  config.params.filter.where = normalizeSchoolUserContactSearchWhere(config.params.filter.where);

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/users`, config).then(response => {
    return response.data;
  });
}

export function searchGovernors(user: AppUser, filter): Promise<{ items: any[]; total: number }> {
  const { roleSessionKey: key, activeSchoolId } = user;
  const requestFilter = {
    ...filter,
    where: normalizeSchoolUserContactSearchWhere({ ...DEFAULT_GOVERNORS_FILTER, ...(filter.where || {}) })
  };
  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/users/search`, requestFilter, { headers: { usid: key } })
    .then(response => response.data);
}

/** GOVERNORS TABLE */
export function getAllGovernors(user: AppUser, where?) {
  return fetchAllSearchPages(filter => searchGovernors(user, filter), where || {});
}

export function getGovernorsCount(user: AppUser, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...DEFAULT_GOVERNORS_FILTER,
            ...where
          }
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...DEFAULT_GOVERNORS_FILTER
          }
        }
      }
    };
  }

  config.params.filter.where = normalizeSchoolUserContactSearchWhere(config.params.filter.where);

  return axios.get<Count>(`${window.apiBase}/i/schools/${activeSchoolId}/users/count`, config).then(response => {
    return response.data;
  });
}
